export default function CStatic() {
  return <h2>C Static</h2>;
}
